import { useLocation, useNavigate, useParams } from 'react-router-dom';

export const withRouter = (Component) => {
  const Wrapper = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return (
      <Component
        {...props}
        router={{ navigate, params, location }}
        location={location} // optional: keep direct location prop for compatibility
      />
    );
  };

  return Wrapper;
};
